(() => {
  'use strict';
  function init(scope=document) {
    let saved;
    try { saved=JSON.parse(sessionStorage.getItem('ardanshield-finder-review-v1')); } catch { return; }
    if (!saved || typeof saved.text !== 'string' || saved.text.length > 3000 || !Number.isFinite(saved.created) || Date.now()-saved.created > 1800000 || saved.created > Date.now()) return;
    scope.querySelectorAll('form[action*="/contact"] textarea[name="contact[body]"]').forEach(field=>{
      if (field.dataset.finderTransfer) return;
      field.dataset.finderTransfer='ready';
      const panel=document.createElement('div'), description=document.createElement('p'), button=document.createElement('button');
      description.textContent=saved.notice;button.textContent=saved.button;button.type='button';button.className='global-button global-button--secondary';
      panel.append(description,button);field.parentNode.insertBefore(panel,field);
      button.addEventListener('click',()=>{
        field.value=(field.value ? field.value+'\n\n' : '')+saved.text;
        field.dispatchEvent(new Event('input',{bubbles:true}));field.focus();panel.remove();
        try {sessionStorage.removeItem('ardanshield-finder-review-v1');} catch {}
      },{once:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
